
import type { PropOptions } from 'vue';
import Vue from 'vue';
import type { Validation } from 'vuelidate';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import JobsStep from '~/components/partials/jobs/JobsStep.vue';
import JobsNextButton from '~/components/partials/jobs/JobsNextButton.vue';
import JobsInput from '~/components/partials/jobs/JobsInput.vue';
import { loadingState } from '~/components/common/constants';
import type { Testimonial } from '~/types/graphql';
import type { FormState } from '~/types/common';

export default Vue.extend({
  name: 'PublicPortfolioTestifyInfo',
  components: { JobsInput, JobsStep, JobsNextButton },
  mixins: [validationMixin],
  props: {
    testimonial: {
      type: Object,
      required: true,
    } as PropOptions<Testimonial>,
    formState: {
      type: String,
      required: true,
    } as PropOptions<FormState>,
  },
  data() {
    return {
      author: {
        firstname: this.testimonial.author.firstname,
        lastname: this.testimonial.author.lastname,
      },
    };
  },
  validations: {
    author: {
      firstname: { required },
      lastname: { required },
    },
  },
  computed: {
    inputStyle(): Record<string, string> {
      return { padding: '12px 16px', fontSize: '15px', lineHeight: '24px' };
    },
    isButtonDisabled(): boolean {
      return (this.$v.author.$dirty && this.$v.author.$invalid) || this.formState === loadingState.SUBMITTING;
    },
    isFirstnameValid(): boolean {
      return !(this.$v.author.$dirty && (this.$v.author.firstname as Validation).$invalid);
    },
    isLastnameValid(): boolean {
      return !(this.$v.author.$dirty && (this.$v.author.lastname as Validation).$invalid);
    },
  },
  methods: {
    handleSave(): void {
      this.$v.author.$touch();
      if (!this.$v.author.$invalid) {
        this.$emit('next', { author: { ...this.testimonial.author, ...this.author } });
      }
    },
  },
});
